import { KeyValuePair } from "@/types";

const toQueryString = (params: KeyValuePair<string | number>): string => {
  return Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join("&");
};

export default toQueryString;
